import React, { useState } from "react";
import { FormControl } from "react-bootstrap";
import { X, Search as SearchIcon } from "react-bootstrap-icons";

function Search({ onSearch }) {
  const [query, setQuery] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setQuery("");
      onSearch(""); // Appeler la fonction de recherche avec une chaîne vide
      return;
    }

    // Mettre à jour la requête et appeler la fonction de recherche
    // pour filtrer les articles en fonction de la requête
    setQuery(value);
    onSearch(value);
  };

  const handleClear = () => {
    setQuery("");
    onSearch("");
  };

  return (
    <div className='position-relative mb-3 w-100'>
      <label htmlFor='search-input' className='visually-hidden'>
        Rechercher un article
      </label>
      <span
        className='position-absolute'
        style={{
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#6c757d",
          pointerEvents: "none",
          zIndex: 2,
        }}>
        <SearchIcon size={20} />
      </span>
      <FormControl
        id='search-input'
        placeholder='Rechercher un article'
        value={query}
        onChange={handleChange}
        onClick={handleChange}
        onFocus={handleChange}
        className='border-success ps-5 pe-5'
        aria-label='Rechercher un article'
        style={{ minWidth: 0 }}
      />
      {query && (
        <button
          type='button'
          className='btn p-0 border-0 bg-transparent position-absolute'
          style={{ top: "50%", right: "10px", transform: "translateY(-50%)" }}
          onClick={handleClear}
          tabIndex={0}
          aria-label='Effacer la recherche'>
          <X size={30} />
        </button>
      )}
    </div>
  );
}

export default Search;
